export default "__VITE_ASSET__CDQH2PhH__"